import React, { useState } from "react";
import DFESummary from "./DFESummary.js";
import utils from '../../common/utils.js';
import metrics from '../services/metrics.js';
import FilterModal from './modals/FilterModal.js';

export default function DFEForm( props ) {
	const data = props.data;
	const widgetModel = data.widgetModel;
	const widgetOptions = widgetModel?.options;
	const setSearchQuery = data.setSearchQuery;
	const getPosts = data.getPosts;
	const setPage = data.setPage;
	let selectedMockFilters = [];

	const [search, setSearch] = useState('');

	// if in editor, filters
	if (widgetModel.isStatic){
		if (widgetModel.staticData?.filters) {
			selectedMockFilters = selectedMockFilters.concat(widgetModel.staticData?.filters);
		}
		if (selectedMockFilters.length) {
			selectedMockFilters = selectedMockFilters.filter((filter) => widgetOptions.filters.some((elem) => filter.id === elem.id) );
		}
	}

	// if form is optionally hidden, return now
	if (widgetModel.hideForm) {
		return '';
	}

	// form blocks
	let blocks = [];

	const doSearch = () => {
		setSearchQuery(search);
		setPage(1);
		getPosts();
	};

	const clearSearch = () => {
		setSearchQuery('');
		setSearch('');
		setPage(1);
		getPosts();
	}
	const renderSearch = () => {
		return (
			<div className="input-group search dfe-search">
				<input
					className="form-control search-box"
					aria-label="Search"
					value={search}
					placeholder="SEARCH"
					onChange={(e) => {
						setSearch(e.currentTarget.value);
					}}
					onKeyUp={(e) => {
						if ('enter' === String(e.key).toLowerCase()) {
							metrics.clickTrack(e, 'cc-search', 'key');
							doSearch();
						}
					}}
				/>
				<button onClick={clearSearch} className={`${search.length > 0 ? 'show' : 'hide'} form-control-clear`}>&times;</button>
				<div className="input-group-append">
					<button
						className="btn btn-search search-submit search-button"
						type="button"
						onClick={(e) => {
							metrics.clickTrack(e, 'cc-search', 'click');
							doSearch();
						}}
						onKeyUp={(e) => {
							if ('enter' === String(e.key).toLowerCase()) {
								metrics.clickTrack(e, 'cc-search', 'key');
								doSearch();
							}
						}}
					>
						<i className="fi cdc-icon-magnify x24" aria-label="search"></i>
					</button>
				</div>
			</div>
		);
	};

	const renderCounts = () => {
		let message = data.allTotal + ' result' + utils.pluralize(data.allTotal, 's');
		if (data.total !== data.allTotal) {
			message = data.total + ' result' + utils.pluralize(data.total, 's');
		}
		// When blank, the 0 results is redundant, hide counts
		if (!data.total) {
			return '';
		}
		return <div className="dfe-widget-form-counts"><span className="dfe-widget-form-counts-text">{message}</span></div>;
	};

	if (widgetOptions.form.search) {
		blocks.push(renderSearch());
	}


	return (
		<>
			{ !blocks.length ? (
				<>
					<div className="dfe-summary-pills-container">
						<div className="dfe-summary-filters-container">
							{widgetOptions.form.counts  ? renderCounts() : ''}
							<FilterModal data={data}></FilterModal>
						</div>
							<DFESummary data={data}></DFESummary>
					</div>
				</>
			):(
			<>
				<div className="dfe-widget-form">
					<div className="row dfe-widget-form-row">
						{blocks.map((block, blockId) => {
							return (
								<div key={'block-' + blockId} className="dfe-widget-form-search-container">
									{block}
								</div>
							);
						})}
					</div>
				</div>
				<div className="dfe-summary-pills-container">
					<div className="dfe-summary-filters-container">
						{widgetOptions.form.counts  ? renderCounts() : ''}
						<FilterModal data={data}></FilterModal>
					</div>
						<DFESummary data={data}></DFESummary>
				</div>
			</>
			)}
		</>
	);


}
